// Fit every visible widget into a common bounding box, including negative positions.
export const layoutPreviewRects = (layout) => {
  const widgets = Object.entries(layout?.widgetStates || {})
    .filter(([, state]) => state?.visible)
    .map(([id, state]) => ({
      id, x: Number(state.position?.left) || 0, y: Number(state.position?.top) || 0,
      width: Math.max(1, Number(state.size?.width) || 300),
      height: Math.max(1, Number(state.size?.height) || 220),
    }));
  if (!widgets.length) return [];
  const left = Math.min(...widgets.map(w => w.x));
  const top = Math.min(...widgets.map(w => w.y));
  const width = Math.max(...widgets.map(w => w.x + w.width)) - left;
  const height = Math.max(...widgets.map(w => w.y + w.height)) - top;
  const scale = Math.min(90 / width, 45 / height);
  const offsetX = (100 - width * scale) / 2;
  const offsetY = (100 - height * scale * 2) / 2;
  return widgets.map(w => ({ id: w.id, style: {
    left: `${offsetX + (w.x - left) * scale}%`, top: `${offsetY + (w.y - top) * scale * 2}%`,
    width: `${w.width * scale}%`, height: `${w.height * scale * 2}%`,
  } }));
};
